import { useDelete } from "@refinedev/core";
import { Modal, Form, Input, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useResourceInvalidate } from "./useResourceInvalidate";
import { useResourceContext } from "@/layouts/ResourceContext";
import { useEffect } from "react";

export const useResourceDelete = () => {
  
  const { t } = useTranslation();
  const invalidate = useResourceInvalidate();
  const { mutateAsync: originalMutateAsync  } = useDelete();
  const { tenantName } = useResourceContext();
  const meta = {}
  if(tenantName) {
    meta.tenantName = tenantName;
  }
  const mutateAsync = async (params) => {
    const { promise, resolve, reject } = Promise.withResolvers();
    const { resource, id } = params;
    const dialog = Modal.confirm({
      title: t(`${resource}.confirm.delete.title`, { id, }),
      content: <DeleteConfirmCtrl content={t(`${resource}.confirm.delete.content`, { id, })} id={id} 
                  setConfirmed={(bool) => dialog.update({okButtonProps:{ disabled: !bool }})}/>,
      onOk: async () => {
        try {
          await originalMutateAsync(
            {
              successNotification: (data, values, resource) => {
                return {
                  message: t(`${resource}.actionResult.delete.success`, { id, }),
                  type: "success",
                };
              },
              errorNotification: (data, values, resource) => {
                return {
                  message: t(`${resource}.actionResult.delete.failed`, { id, }),
                  type: "error",
                };
              },
              ...params,
              meta
            });
          resolve();
        } catch (e) {
          reject(e);
        }
      },
    });
    return promise;
  };
  return { mutateAsync };
};
export const DeleteConfirmCtrl = ({content, id, setConfirmed}) => {
  const [modalForm] = Form.useForm();

    const values = Form.useWatch([], modalForm);
    useEffect(() => {
        modalForm
        .validateFields({
            validateOnly: false,
        })
        .then(() => {
            setConfirmed(true);
        })
        .catch(() => {
            setConfirmed(false);
        });
    }, [modalForm, values]);

  return (<Space
    direction="vertical"
    size="middle"
    style={{
      display: 'flex',
    }}
  >
   <div> {content} </div> 
  <Form form={modalForm} layout="vertical">
    <Form.Item
        name="in"
        label=""
        rules={[   
            {
                validator: (_, value) =>
                    value == id ? Promise.resolve() : Promise.reject(`Please input \'${id}\' to confirm.`),
            },
        ]}
    >
        <Input size="small" placeholder={id}/>
    </Form.Item>
    </Form></Space>);
}